// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"7ddee595","141":"bf19a901","284":"1565a4f4","318":"89ebc673","453":"5d79306b","531":"429d2f4f","686":"f75c538f","807":"ac75b85c"}[chunkId] + ".chunk.js";
};